<section aria-labelledby="list-builder" role="dialog" class="h-100">
	<header>
		<h4 class="mb-0">
			<img src="content/images/list-builder.png"/>
			<span jhiTranslate="list-builder.header"></span>
		</h4>
	</header>
	<div class="card h-100">
		<div class="card-body d-flex flex-column">
			<h5>
				<img src="content/images/list-entries.png" />
				<span jhiTranslate="list-builder.entries"></span>
			</h5>
			<div jhiTranslate="list-builder.description"></div>
			<div class="row my-2">
				<div class="col d-flex flex-wrap align-items-center">
					<span class="me-1 fw-bold" jhiTranslate="global.total.entries" [translateValues]="{param: data.length}"></span>
					<span class="ms-3 me-1 fw-bold" jhiTranslate="global.selected"></span>
					<span>{{isSelectAllPages ? data.length : size(selectedItems)}}</span>
					<div class="form-check form-check-inline ms-3">
						<input type="checkbox" class="form-check-input" [checked]="isSelectAllPages" (click)="onSelectAllPages()" id="list-builder-select-all">
						<label class="form-check-label ms-1" for="list-builder-select-all" jhiTranslate="global.select.all"></label>
					</div>
					<div ngbDropdown class="ms-auto" placement="bottom-right">
						<button class="btn btn-info" id="actionMenu" ngbDropdownToggle [disabled]="!data.length">
							<span>{{'actions' | translate}}</span>
						</button>
						<div ngbDropdownMenu aria-labelledby="actionMenu">
							<button class="dropdown-item" type="submit" (click)="deleteSelected()" jhiTranslate="list-builder.delete.selected.items">
							</button>
							<button class="dropdown-item" type="submit" (click)="deleteDuplicates()" jhiTranslate="list-builder.delete.duplicated.items">
							</button>
                            <button class="dropdown-item" type="submit" (click)="reorderSelectedEntries()" jhiTranslate="list-builder.reorder.selected.entries">
                            </button>
						</div>
					</div>
				</div>
			</div>
			<div class="table-responsive flex-grow-1"
				 id="listBuilderDrop" cdkDropList (cdkDropListDropped)="drop($event)"
				 (contextmenu)="showRightClickMenu($event)">
				<table class="table table-striped table-bordered table-curved">
					<thead>
                        @if (!data.length) {
                            <tr>
                                <th></th>
                            </tr>
                        } @else {
                            <tr>
                                <th *ngIf="data.length && !isSelectAllPages">
                                    <input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]="'global.select.current.page' | translate" />
                                </th>
                                <th *ngIf="data.length">#</th>
                                <th *ngFor="let header of headers()">
                                    <span>{{getHeaderDisplay(header)}}</span>
                                </th>
                            </tr>
                        }
					</thead>
                    <tbody>
						<tr *ngFor="let row of data | slice: pageOffset() : page * context.pageSize; let index = index"
							[class.selected]="isSelected(row.internal_id)"
							(click)="toggleSelect($event, index, row.internal_id)"
							cdkDrag >
							<td *ngIf="!isSelectAllPages">
								<input type="checkbox" class="form-check-input" [checked]="isSelected(row.internal_id)" (click)="toggleSelect($event, index, row.internal_id, true); $event.stopPropagation()">
							</td>
							<td>{{pageOffset() + index + 1}}</td>
							<td *ngFor="let header of headers()">
								<span *ngIf="header === 'NAMES' || header === CROSS" ><truncate-span [textInput]="row[header]" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span>
                                <a class="link" *ngIf="header === 'GID'" (click)="germplasmDetailsPopupService.open(row[header])"><truncate-span [textInput]="row[header]"></truncate-span></a>
                                <a class="link" *ngIf="header === 'DESIGNATION'" (click)="germplasmDetailsPopupService.open(row['GID'])"><truncate-span [textInput]="row[header]" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
								<a *ngIf="header === 'LOTS' && row[header] !== 0" (click)="$event.stopPropagation(); inventoryDetailsPopupService.open(row['GID'])">{{row[header]}}</a>
								<span *ngIf="(header === 'LOTS' || this.isRegularColumn(header)) && row[header] === 0">-</span>
								<span *ngIf="this.isRegularColumn(header) && row[header] !== 0"><truncate-span [textInput]="row[header]" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span>
							</td>
						</tr>
						<tr *ngIf="!data.length">
							<td jhiTranslate="list-builder.no.data"></td>
						</tr>
					</tbody>
				</table>

				<div class="popup" *ngIf="displayMenuPopup" [ngStyle]="getRightClickMenuStyle()">
					<div tabindex="0" role="menubar" class="dropdown-menu dropdown-menu-end show" hidefocus="true" aria-activedescendant="gwt-uid-21" style="outline: 0px; background-color: white;">
						<input type="text" tabindex="-1" role="presentation" style="opacity: 0; height: 1px; width: 1px; z-index: -1; overflow: hidden; position: absolute;">
						<div aria-labelledby="actionMenu">
							<button *ngIf="!isSelectAllPages" class="dropdown-item" type="submit" (click)="onSelectAllPages()" jhiTranslate="global.select.all">
							</button>
							<button *ngIf="isSelectAllPages" class="dropdown-item" type="submit" (click)="onSelectAllPages()" jhiTranslate="list-builder.deselect.all">
							</button>
							<button class="dropdown-item" type="submit" (click)="deleteSelected()" jhiTranslate="list-builder.delete.selected.items">
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="pagination-container">
						<div class="pagination-box pagination-box-left">
							<div>
								<jhi-item-count [page]="page" [total]="data.length" [itemsPerPage]="context.pageSize"></jhi-item-count>
							</div>
						</div>
						<div class="pagination-box pagination-wrap">
							<ngb-pagination [collectionSize]="data.length" [(page)]="page" [pageSize]="context.pageSize"
											[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
						</div>
						<div class="pagination-box pagination-box-right">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer d-flex justify-content-end" *ngIf="data.length">
			<button type="button" class="btn btn-secondary" (click)="reset()" [disabled]="!data.length">
				<span jhiTranslate="reset"></span>
			</button>
			<button (click)="save()" class="btn btn-primary ms-2" [disabled]="!data.length">
				<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="save"></span>
			</button>
		</div>
	</div>
</section>
